import type { TFunction } from "i18next";
import { API_USER_PROJECTROLE } from "General/APIEnums";

export const PROJECT_ROLE_I18N_KEYS = {
  USER: "User",
  INFO: "Passive",
  HID: "Hidden",
  ADMIN: "Administrator",
  ARCHIVE_ADMIN: "Archive admin",
  NONE: "None",
} as const satisfies Record<API_USER_PROJECTROLE, string>;

export const ASSIGNABLE_PROJECT_ROLES = [
  API_USER_PROJECTROLE.USER,
  API_USER_PROJECTROLE.INFO,
  API_USER_PROJECTROLE.HID,
  API_USER_PROJECTROLE.ADMIN,
] as const;

export type AssignableProjectRole = (typeof ASSIGNABLE_PROJECT_ROLES)[number];

export const isProjectRole = (value: unknown): value is API_USER_PROJECTROLE =>
  typeof value === "string" && value in PROJECT_ROLE_I18N_KEYS;

export const getProjectRoleLabel = (role: API_USER_PROJECTROLE | string | undefined, t: TFunction): string => {
  if (!isProjectRole(role)) {
    return role ?? "";
  }

  return t(PROJECT_ROLE_I18N_KEYS[role], { ns: "general" });
};

export const getProjectRoleSelectOptions = (
  t: TFunction,
  roles: readonly API_USER_PROJECTROLE[] = ASSIGNABLE_PROJECT_ROLES
) =>
  roles.map((value) => ({
    value,
    label: getProjectRoleLabel(value, t),
  }));

export const getProjectRoleTableFilters = (
  t: TFunction,
  roles: readonly API_USER_PROJECTROLE[] = ASSIGNABLE_PROJECT_ROLES
) =>
  roles.map((value) => ({
    value,
    text: getProjectRoleLabel(value, t),
  }));

export const labelProjectRoleFilters = <T extends { value: string }>(
  filters: T[],
  t: TFunction
): Array<T & { text: string }> =>
  filters.map((filter) => ({
    ...filter,
    text: getProjectRoleLabel(filter.value, t),
  }));
